import React, { useEffect, useMemo, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useHistory, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { daysData, upperCase } from "../../constant/api";
import useRequest from "../../hooks/useRequest";
import StepOne from "./Outlet/StepOne";
import StepTwo from "./Outlet/StepTwo";
import StepThree from "./Outlet/StepThree";
import StepFour from "./Outlet/StepFour";
import StepFive from "./Outlet/StepFive";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

const mapOutletResponseToSteps = (outletData, outletId) => {
  const safeMapIds = (items = []) =>
    items.map((item) => item?._id).filter(Boolean);
  const allDetail = outletData?.allDetail || {};

  return {
    vendorId: outletData?.vendorId || outletData?.vendor?._id || "",
    outletId,
    vendorSubCategory: (outletData?.subCategory || []).map((item) => ({
      value: item?._id,
      label: upperCase(item?.name || ""),
    })),
    outletName: outletData?.name || "",
    posId: outletData?.posId || "",
    posName: outletData?.posName || "",
    cuisine: safeMapIds(outletData?.cuisineCategory),
    meals: safeMapIds(outletData?.mealsCategory),
    payment: safeMapIds(outletData?.paymentCategory),
    parking: safeMapIds(outletData?.parkingCategory),
    dish: safeMapIds(outletData?.dishCategory),
    themes: safeMapIds(outletData?.themeType),
    otherAttractions: safeMapIds(outletData?.otherAttraction),
    otherFacilities: safeMapIds(outletData?.otherFacilities),
    moreFacilities: safeMapIds(outletData?.moreFacilities),
    hoursData:
      outletData?.openingHours?.length > 0
        ? outletData.openingHours
        : allDetail?.openingHours?.length > 0
          ? allDetail.openingHours
          : daysData,
    tax:
      allDetail?.tax?.length > 0
        ? allDetail.tax
        : [
            { title: "Cgst", amount: "2.5", taxOn: "food", applyOn: "" },
            { title: "Sgst", amount: "2.5", taxOn: "food", applyOn: "" },
          ],
    description: outletData?.aboutVendor || "",
    coverPicture: allDetail?.coverPicture?.length ? allDetail.coverPicture : [],
    image: allDetail?.otherImage?.length ? allDetail.otherImage : [],
    facadeImage: allDetail?.facadeImage?.length ? allDetail.facadeImage : [],
    interiorsImage: allDetail?.interiorsImage?.length
      ? allDetail.interiorsImage
      : [],
    sittingImage: allDetail?.sittingImage?.length ? allDetail.sittingImage : [],
    staffImage: allDetail?.staffImage?.length ? allDetail.staffImage : [],
    savedData: true,
    savedCoverPicture: true,
    savedfacadePicture: true,
    savedInteriorsPicture: true,
    savedSittingPicture: true,
    savedStaffPicture: true,
    savedOtherPicture: true,
    name: outletData?.managerDetail?.name || "",
    email: outletData?.managerDetail?.email || "",
    mobile: outletData?.managerDetail?.mobile || "",
    password: outletData?.managerDetail?.password || "",
    country: allDetail?.country || "",
    state: allDetail?.state || "",
    city: allDetail?.city || "",
    address: allDetail?.address || "",
    street: allDetail?.street || "",
    landMark: allDetail?.landMark || "",
    pincode: allDetail?.pincode || "",
    latitude: allDetail?.latitude || "",
    longitude: allDetail?.longitude || "",
  };
};

const EditOutlet = () => {
  const { id } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const vendorId = params.get("vendorId");
  const history = useHistory();
  const { request, response, loading } = useRequest();
  const [nextStep, setNextStep] = useState(1);
  const [allStepsData, setAllFormData] = useState({});

  useEffect(() => {
    if (!id) {
      history.push("/vendors");
      return;
    }
    request("POST", "vendor/outlet/getOutletDetail", {
      outletId: id?.split("?")[0],
    });
  }, [history, id]);

  useEffect(() => {
    if (!response) {
      return;
    }

    if (response?.status && response?.data) {
      setAllFormData(
        mapOutletResponseToSteps({ vendorId: vendorId, ...response.data }, id),
      );
      return;
    }

    toast.error(response?.message || "Unable to load outlet details.");
    history.push("/vendors");
  }, [history, id, response]);

  const sharedProps = useMemo(
    () => ({
      allStepsData,
      setAllFormData,
      handleNextStep: setNextStep,
      outletId: id?.split("?")[0],
      isEdit: true,
    }),
    [allStepsData, id],
  );

  const renderContent = () => {
    switch (nextStep) {
      case 1:
        return <StepOne {...sharedProps} />;
      case 2:
        return <StepTwo {...sharedProps} />;
      case 3:
        return <StepThree {...sharedProps} />;
      case 4:
        return <StepFour {...sharedProps} />;
      case 5:
        return <StepFive {...sharedProps} />;
      default:
        return <StepOne {...sharedProps} />;
    }
  };

  if (loading && !allStepsData?.outletId) {
    return (
      <div className="ms-content-wrapper d-flex justify-content-center py-5">
        <Spinner animation="border" />
      </div>
    );
  }

  return renderContent();
};

export default EditOutlet;
